import { AxiosResponse } from "axios"
import { ICreateProfileField, IProfileField, IProfileTemplate, IUpdateProfileField } from "./types"
import { apiInstance } from "../base"
import { RoleType } from "../users"

export const createProfileField = (data: ICreateProfileField): Promise<AxiosResponse<IProfileField>> => {
    return apiInstance.handler.post<IProfileField>(`/profile-fields`, data)
}
export const updateProfileField = (id: string, data: IUpdateProfileField): Promise<AxiosResponse<IProfileField>> => {
    return apiInstance.handler.put<IProfileField>(`/profile-fields/${id}`, data)
}
export const deleteProfileField = (id: string): Promise<AxiosResponse<IProfileField>> => {
    return apiInstance.handler.delete<IProfileField>(`/profile-fields/${id}`)
}
export const getProfileTemplateByRole = (role_id: RoleType): Promise<AxiosResponse<IProfileTemplate>> => {
    return apiInstance.handler.get<IProfileTemplate>(`/roles/${role_id}/profile-template`)
}
